import { useNavigate, Link as RouterLink, Link, useLocation } from 'react-router-dom';
import React ,{ useEffect, useState } from 'react';
import { Box, Typography, Container, FormControlLabel, Radio, RadioGroup, Button, Modal, Checkbox } from '@mui/material';
import "./App.css"; // CSSファイルをインポート
import api from './api';
import FormRequire from './FormRequire';
import Comp3Sub from './Comp3Sub';
import Comp4Sub from './Comp4Sub';
import FormElectricity from './FormElectricity';
import Comp7Sub from './Comp7Sub';
import Comp8Sub from './Comp8Sub';
import Comp9Sub from './Comp9Sub';
import Comp10Sub from './Comp10Sub';
import Comp11Sub from './Comp11Sub';
import Comp12Sub from './Comp12Sub';
import Comp13Sub from './Comp13Sub';
import Header from './components/Header';
import { useConfirmBackLogout } from './common/useConfirmBackLogout';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import { createRoot } from "react-dom/client";
import Comp3PDF from "./Comp3PDF.js";
import Comp4PDF from "./Comp4PDF.js";
import Comp7PDF from "./Comp7PDF.js";
import Comp8PDF from "./Comp8PDF.js";
import Comp9PDF from "./Comp9PDF.js";
import Comp10PDF from "./Comp10PDF.js";
import Comp10_1PDF from "./Comp10_1PDF.js";
import Comp10_2PDF from './Comp10_2PDF.js';
import Comp11_2PDF from './Comp11_2PDF.js';
import Comp11PDF from "./Comp11PDF.js";
import Comp12PDF from "./Comp12PDF.js";
import Comp13PDF from "./Comp13PDF.js";
import FormRequirePDF from "./FormRequirePDF";
import FormElectricityPDF from "./FormElectricityPDF.js";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Comp6Sub from './Comp6Sub.js';
import Comp5Sub from './Comp5Sub.js';
import Comp11_2Sub from './Comp11_2Sub.js';
import Comp10_2Sub from './Comp10_2Sub.js';

const CoExhibitMypage = () => {
  const FIELD_CONFIGS = [
    {
      key: 'r1',
      label: '必須書類',
      category: 1,
    },
    {
      key: 'o3',
      label: '運送・会場内荷役',
      category: 3,
    },
    {
      key: 'o4',
      label: '床面工事',
      category: 4,
    },
    {
      key: 'o5',
      label: '電気使用',
      category: 5,
    },
    {
      key: 'o6',
      label: '電気備品',
      category: 6,
    },
    {
      key: 'o7',
      label: '給排水・エア・ガス',
      category: 7,
    },
    {
      key: 'o8',
      label: 'パッケージ装飾等',
      category: 8,
    },
    {
      key: 'o9',
      label: '装飾備品レンタル',
      category: 9,
    },
    {
      key: 'o10',
      label: 'PC・ソフトレンタル',
      category: 10,
    },
    {
      key: 'o10_2',
      label: 'インターネット接続',
      category: 14,
    },
    {
      key: 'o11',
      label: '危険物品',
      category: 11,
    },
    {
      key: 'o11_2',
      label: '防炎対象物',
      category: 15,
    },
    {
      key: 'o12',
      label: 'ゴミ・廃材・廃油処理',
      category: 12,
    },
    {
      key: 'o13',
      label: 'ブース平面図',
      category: 13,
    },
  ];
  const user = JSON.parse(localStorage.getItem("user"));
  const [parentExhibit, setParentExhibit] = useState(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    return user?.parent_exhibit;
  });
  const [ownExhibit, setOwnExhibit] = useState(''); // 自社出展する・しないの状態
  const [mypageData, setMypageData] = useState(null);
  const [coMypageData, setCoMypageData] = useState(null);
  const [statusData, setStatusData] = useState(null);
  const [coStatusData, setCoStatusData] = useState(null);
  const [canDownload, setCanDownload] = useState(false);
  const [mypageModalOpen, setMypageModalOpen] = useState(false);
  const [mypageExhibitorId, setMypageExhibitorId] = useState(null);
  const [exhibitors, setExhibitors] = useState([]);
  const [filteredExhibitors, setFilteredExhibitors] = useState([]);
  const itemsPerPage = 150;
  const [exhibitorPage, setExhibitorPage] = useState(1);
  const paginatedExhibitors = filteredExhibitors.slice(
    (exhibitorPage - 1) * itemsPerPage,
    exhibitorPage * itemsPerPage
  );
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  const [notices, setNotices] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const noticesPerPage = 5;

  useEffect(() => {
    const fetchNotices = async () => {
      try {
        const res = await api.get(`/api/notices?skip=${(page - 1) * noticesPerPage}&limit=${noticesPerPage}`);
        setNotices(res.data.items);
        setTotal(res.data.total);
      } catch (err) {
        console.error('お知らせ一覧の取得に失敗:', err);
      }
    };
    fetchNotices();
  }, [page]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    const scrollToId = localStorage.getItem('scrollToId');
    if (scrollToId) {
      // requestAnimationFrame で描画完了後にスクロール
      requestAnimationFrame(() => {
        const el = document.getElementById(scrollToId);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        localStorage.removeItem('scrollToId');
      });
    }
  }, []);

  const handleScrollTo = (id, targetUrl) => {
    if (targetUrl && window.location.pathname !== targetUrl) {
      // 別ページなら localStorage に保存して navigate
      localStorage.setItem('scrollToId', id);
      navigate(targetUrl);
    } else {
      // 同ページなら即スクロール
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        const res1 = await api.get(`/api/mypage/${user.exhibitor_id}`);
        setMypageData(res1.data);
        setCanDownload(res1.data.can_download || false);
      } catch (err) {
        console.error("mypageデータ取得エラー:", err);
        setMypageData(null); // or 空オブジェクトにするか検討
        setCanDownload(false);
      }

      try {
        const user = JSON.parse(localStorage.getItem('user'));
        const res2 = await api.get(`/api/submission-status/${user.mypage_id}`);
        setStatusData(res2.data);
      } catch (err) {
        console.error("submission-status取得エラー:", err);
        setStatusData(null);
      }

      try {
        const user = JSON.parse(localStorage.getItem('user'));
        const res3 = await api.get(`/api/co-exhibit-status/${user.mypage_id}`);
        setCoStatusData(res3.data);
        console.log(res3.data)
      } catch (err) {
        console.error("co-status取得エラー:", err);
        setCoStatusData(null);
      }
    };
    fetchData();
  }, []);

  const [selectedFormKey, setSelectedFormKey] = useState(null);
  const [selectedExhibitorId, setSelectedExhibitorId] = useState(null);
  const [formModalOpen, setFormModalOpen] = useState(false);
  const [searchStatus, setSearchStatus] = useState('');
  const [filterRequired, setFilterRequired] = useState(true);
  const [filterOptional, setFilterOptional] = useState(true);
  const [filterContractor, setFilterContractor] = useState(true);

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);

    api
      .get("/api/co-dashboard", {
        params: {
          status: searchStatus,
          representative_id: user?.representative_id,
        },
      })
      .then(async (res) => {
        setExhibitors(res.data);
        setFilteredExhibitors(res.data);

        // --- 判定処理 ---
        const allClear = res.data.every((ex) => {
          const checkFields = [
            { host: ex.r1_host_status, corp: ex.r1_corporate_status },
            { host: ex.o3_host_status, corp: ex.o3_corporate_status },
            { host: ex.o4_host_status, corp: ex.o4_corporate_status },
            { host: ex.o5_host_status, corp: ex.o5_corporate_status },
            { host: ex.o7_host_status, corp: ex.o7_corporate_status },
            { host: ex.o8_host_status, corp: ex.o8_corporate_status },
            { host: ex.o9_host_status, corp: ex.o9_corporate_status },
            { host: ex.o10_host_status, corp: ex.o10_corporate_status },
            { host: ex.o11_host_status, corp: ex.o11_corporate_status },
            { host: ex.o12_host_status, corp: ex.o12_corporate_status },
            { host: ex.o13_host_status, corp: ex.o13_corporate_status },
            // 必要な分だけ追加
          ];

          return checkFields.every(
            (f) =>
              (f.host === "確認済み" || f.host === "申請しない") &&
              (f.corp === "確認済み" || f.corp === "申請しない")
          );
        });

        if (allClear) {
          try {
            const subsRes = await api.get("/api/exhibitor/all-subs/", {
              params: { representative_id: user?.representative_id },
            });
            setCoStatusData(subsRes.data);
          } catch (err) {
            console.error("all-subs取得失敗:", err);
          }
        }
      })
      .catch((err) => console.error("co-dashboard取得失敗:", err))
      .finally(() => setLoading(false));
  }, [searchStatus, user?.representative_id]);
  const now = new Date(); // 現在の日時

  const getVisibleFields = () => {
    const isAnyFilterChecked = filterRequired || filterOptional || filterContractor;
    if (!isAnyFilterChecked) return FIELD_CONFIGS;

    return FIELD_CONFIGS.filter((field) => {
      const isContractor = field.contractor === true;

      const isRequiredMatch = filterRequired && field.required && !isContractor;
      const isOptionalMatch = filterOptional && !field.required && !isContractor;
      const isContractorMatch = filterContractor && isContractor;

      return isRequiredMatch || isOptionalMatch || isContractorMatch;
    });
  };
  const renderForm = (formKey, exhibitorId) => {
    const key = `${formKey}-${exhibitorId}`;
    switch (formKey) {
      case 'r1':
        return (
          <FormRequire
            key={key}
            exhibitorId={exhibitorId}
            isModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={setFormModalOpen}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
      case 'o3':
        return (
          <Comp3Sub
            key={key}
            exhibitorId={exhibitorId}
            isModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={setFormModalOpen}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
      case 'o4':
        return (
          <Comp4Sub
            key={key}
            exhibitorId={exhibitorId}
            isModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={setFormModalOpen}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o5':
        return (
          <Comp5Sub
            key={key}
            exhibitorId={exhibitorId}
            isModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={setFormModalOpen}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o6':
        return (
          <Comp6Sub
            key={key}
            exhibitorId={exhibitorId}
            isModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={setFormModalOpen}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o7':
        return (
          <Comp7Sub
            key={key}
            exhibitorId={exhibitorId}
            isModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={setFormModalOpen}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o8':
        return (
          <Comp8Sub
            key={key}
            exhibitorId={exhibitorId}
            isModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={setFormModalOpen}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o9':
        return (
          <Comp9Sub
            key={key}
            exhibitorId={exhibitorId}
            isModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={setFormModalOpen}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o10':
        return (
          <Comp10Sub
            key={key}
            exhibitorId={exhibitorId}
            isModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={setFormModalOpen}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o10_2':
        return (
          <Comp10_2Sub
            key={key}
            exhibitorId={exhibitorId}
            isModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={setFormModalOpen}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o11':
        return (
          <Comp11Sub
            key={key}
            exhibitorId={exhibitorId}
            isModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={setFormModalOpen}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o11_2':
        return (
          <Comp11_2Sub
            key={key}
            exhibitorId={exhibitorId}
            isModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={setFormModalOpen}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o12':
        return (
          <Comp12Sub
            key={key}
            exhibitorId={exhibitorId}
            isModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={setFormModalOpen}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o13':
        return (
          <Comp13Sub
            key={key}
            exhibitorId={exhibitorId}
            isModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={setFormModalOpen}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
      default:
        return <p>フォームが見つかりませんでした</p>;
    }
  };

  const handleStatusClick = async (formKey, exhibitorId) => {

    setSelectedFormKey(formKey);
    setSelectedExhibitorId(exhibitorId);
    console.log("クリックされたformKey:", formKey);

    try {
      setFormModalOpen(true)
    } catch (error) {
      console.error(error);
      alert('エラー');
    }
  };

  useEffect(() => {
    if (mypageModalOpen && mypageExhibitorId != null && exhibitors.length > 0) {
      const exhibitorId = mypageExhibitorId
      if (exhibitorId) {
        api.get(`/api/mypage/${exhibitorId}`)
          .then(res => setCoMypageData(res.data))
          .catch(err => console.error("マイページ取得失敗:", err));
      }
    }
  }, [mypageModalOpen, mypageExhibitorId, exhibitors]);

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/');
  };

  const getImageByStatus = (status) => {
    switch (status) {
      case '確認済':
        return "/status_確認済み.png"; 
      case '提出済み':
        return "/status_確認中.png";
      case '未提出':
        return "/status_未提出.png";
      case '再提出':
        return "/status_再提出.png";
      case '申請しない':
        return "/status_申請しない.png"; 
      default:
        return "/status_未提出.png";
    }
  };

  const getImageByStatusCo = (status) => {
    switch (status) {
      case '確認済':
        return "/status_確認済み.png"; 
      case '提出済み':
        return "/status_確認中.png";
      case '未提出':
        return "/status_未提出.png";
      case '再提出':
        return "/status_再提出.png";
      default:
        return "/status_未提出.png";
    }
  };

  const getStatusImage = (status) => {
      switch (status) {
        case '確認済':
            return '/status_確認済み.png';
        case '確認中':
            return '/status_確認中.png';
        case '未確認':
            return '/status_未確認.png';
        case '1のみ確認済':
            return '/status_1のみ確認済.png';
        case '2のみ確認済':
            return '/status_2のみ確認済.png';
        
        // 👇 提出ステータス追加（例）
        case '提出済み':
            return '/status_確認中.png';
        case '未提出':
            return '/status_未提出.png';
        case '再提出':
            return '/status_再提出.png';
        case '申請しない':
            return '/status_申請しない.png';


        default:
            return '/status_未提出.png';
      }
  };

  const getPreferredStatus = (status, hostStatus) => {
    return hostStatus === "確認済" ? "確認済" : (status || "未提出");
  };

  const getPreferredStatusForElec = (o5Status, o6Status, o5HostStatus, o6HostStatus) => {
      // 最優先：両方確認済
      if (o5HostStatus === "確認済" && o6HostStatus === "確認済") {
          return "確認済";
      }

      // 両方申請しない
      if (o5Status === "申請しない" && o6Status === "申請しない") {
          return "申請しない";
      }

      // どちらかが提出済みで、もう一方が申請しない
      if (
          (o5Status === "提出済み" && o6Status === "申請しない") ||
          (o5Status === "申請しない" && o6Status === "提出済み") ||
          (o5Status === "提出済み" && o6Status === "提出済み")
      ) {
          return "提出済み";
      }

      // 両方未提出
      if (o5Status === "未提出" && o6Status === "未提出") {
          return "未提出";
      }

      // 上記のいずれでもない場合は "未提出" 扱い（または要相談）
      return "未提出";
  };

  const [isHovered, setIsHovered] = useState(false);

   const pdfItems = [
      // { label: 'INDEX', path: '/INDEX.pdf' },
      { label: '出展規定', path: '/出展規定.pdf' },
      { label: '出展者申請システム 操作マニュアル', path: '/出展者申請システム_操作マニュアル.pdf' },
      { label: '色見本', path: '/色見本.pdf' },
      { label: '運送関係のご案内', path: '/運送関係のご案内（ヤマト運輸）.pdf' },
      { label: '宿泊関係のご案内', path: '/宿泊関係のご案内.zip' },
      { label: '飲食関係のご案内', path: '/飲食関係のご案内.zip' },
      { label: '緊急災害時におけるご案内', path: '/緊急災害時におけるご案内.pdf' },
      { label: '出展者用追加パス', path: '/出展者用追加パス.pdf' },
      { label: '小間図面', path: '/小間図面.pdf' },
      { label: '素材集', path: '/素材集.zip' },
      // { label: '出展者駐車許可証(見本)', path: '/出展者駐車場入構許可証兼搬出車両一時停車許可証見本.pdf' },
      // { label: '当日スタッフ', path: '/当日スタッフ.pdf' },
      // { label: '公式アプリ・出展者PR', path: '/公式アプリ・出展者15秒PR.pdf' },
      // { label: '第1展示館の小間図面', path: '/第1展示館の小間図面.pdf' },
      // { label: '出展者一覧', path: '/出展者一覧.pdf' },
      // { label: '出展者へのお願い', path: '/出展者へのお願い.pdf' },
      // { label: '運送関連', path: '/運送関連.zip' },
      // { label: 'グルメッセキッチンカー', path: '/グルメッセキッチンカーについて.pdf' },
      // { label: '出展者操作マニュアル', path: '/出展者操作マニュアル.pdf' },
    ];

   const renderMenuItems = () => (
        <div
          className="menu-item"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <div className="menu-label">資料ダウンロード</div>
          {isHovered && (
            <div className="submenu">
              {pdfItems.map((item, index) => (
                <a key={index} href={item.path} download className="submenu-item">
                  {item.label}
                </a>
              ))}
            </div>
          )}
        </div>
    );

    const [saving, setSaving] = useState(false);

    const deadline = new Date("2025-09-30T23:59:59");
    const today = new Date();

    // 残り日数計算
    const remainingDays = Math.ceil((deadline - today) / (1000 * 60 * 60 * 24));

    const handleSave = async () => {
      if (!ownExhibit) return;

      const user = JSON.parse(localStorage.getItem("user"));
      const exhibitorId = user.exhibitor_id;

      try {
        setSaving(true);

        await api.post("/api/save-own-exhibit", {
          exhibitor_id: exhibitorId,
          parent_exhibit: ownExhibit === "yes", // ← boolで渡す
        });

        // localStorage更新
        const newUser = {
          ...user,
          parent_exhibit: ownExhibit === "yes",
        };
        localStorage.setItem("user", JSON.stringify(newUser));
        setParentExhibit(newUser.parent_exhibit); // ← state更新

        alert("保存しました！");
      } catch (error) {
        console.error(error);
        alert("保存に失敗しました");
      } finally {
        setSaving(false);
      }
    };

    useEffect(() => {
      if (parentExhibit === true) {
        setOwnExhibit("yes");
      } else if (parentExhibit === false) {
        setOwnExhibit("no");
      } else {
        setOwnExhibit(""); // null の場合は選択なし
      }
    }, [parentExhibit]);

  const handlePdfDownload = async (exhibitorId, companyName) => {
    console.log(exhibitorId);
    console.log(companyName);

    try {
      const response = await api.get(
        `/api/pdf-download/${exhibitorId}`,
        {
          responseType: 'blob',
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0'
          },
          params: {
            companyName,
            t: new Date().getTime()
          }
        }
      );

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const safeFileName = companyName.replace(/[\\/:*?"<>|]/g, '_') + '.pdf';

      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute('download', safeFileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      alert("PDFのダウンロードが完了しました。");
    } catch (error) {
      console.error("PDFダウンロードに失敗:", error);
      alert("PDFのダウンロードに失敗しました。");
    }
  };

  const renderMainContent = () => {
    if (parentExhibit === null) {
      return (
        <Box sx={{ margin: 'auto', mt: 4 }}>
          <Typography variant="h6" gutterBottom>
            {mypageData?.company_name}様<br />
            SDGs 子ども・ユースフェアにご出展いただきありがとうございます。<br />
            自社出展はされますか？
          </Typography>
          <RadioGroup
            value={ownExhibit}
            onChange={(e) => setOwnExhibit(e.target.value)}
            row
            aria-label="own-exhibit"
            name="own-exhibit-group"
          >
            <FormControlLabel value="yes" control={<Radio />} label="自社出展する" />
            <FormControlLabel value="no" control={<Radio />} label="自社出展しない" />
          </RadioGroup>
          <Button
            variant="contained"
            sx={{ mt: 2 }}
            onClick={handleSave}
            disabled={saving || ownExhibit === ""}
          >
            保存する
          </Button>
        </Box>
      );
    }

    if (parentExhibit === true) {
    return (
      <>
      <Box sx={{ margin: 'auto', mt: 4 }}>
        <Typography variant="h6" gutterBottom>
          自社（親出展者）の出展有無を選択してください。
        </Typography>
        <RadioGroup
          value={ownExhibit}
          onChange={(e) => setOwnExhibit(e.target.value)}
          row
          aria-label="own-exhibit"
          name="own-exhibit-group"
        >
          <FormControlLabel value="yes" control={<Radio />} label="自社出展する" />
          <FormControlLabel value="no" control={<Radio />} label="自社出展しない" />
        </RadioGroup>
        <Button
          variant="contained"
          sx={{ mt: 2 }}
          onClick={handleSave}
          disabled={saving || ownExhibit === ""}
        >
          保存する
        </Button>
      </Box>
      <Box sx={{ margin: 'auto', mt: 4 }} className="form-status-box">
        <Typography variant="h6" className='form-status-title' gutterBottom>　出展者（親）申請書提出状況</Typography>
        <Container sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
          {/* 必須書類のまま */}
          <Box sx={{ textAlign: 'center', borderBottom: '1px solid #0071BC', pb: 2 }}>
              <Typography>全出展者提出書類<br />出展責任者登録、搬入・搬出計画登録</Typography>
              <img
              src={getImageByStatus(
                  getPreferredStatus(
                  statusData?.r1_status,
                  statusData?.r1_host_status,
                  )
              )}
              alt="必須書類ステータス"
              style={{ width: '60px' }}
              onClick={() => navigate('/form-require')}
              />
          </Box>

          <Typography sx={{textAlign: 'center'}}>希望者・対象者提出書類</Typography>

          {/* 任意書類 横4つずつ */}
          <Box sx={{ display: 'flex', justifyContent: 'space-around', borderBottom: '1px solid #ccc', pb: 1 }}>
              {/* 1〜4個目 */}
              <Box
              sx={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '24%',
                  borderRight: '1px solid #ccc',
                  padding: '0 10px',
                  boxSizing: 'border-box',
                  gap: 1,
                  cursor: 'pointer',
                  '&:last-child': { borderRight: 'none' },
              }}
              onClick={() => navigate('/form-o-3')}
              >
              <img
                  src={getImageByStatus(
                  getPreferredStatus(
                      statusData?.o3_status,
                      statusData?.o3_host_status,
                  )
                  )}
                  alt="パッケージプランステータス"
                  style={{ width: '60px' }}
              />
              <Typography>運送・会場内荷役作業申込</Typography>
              </Box>

              <Box
              sx={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '24%',
                  borderRight: '1px solid #ccc',
                  padding: '0 10px',
                  boxSizing: 'border-box',
                  gap: 1,
                  cursor: 'pointer',
                  '&:last-child': { borderRight: 'none' },
              }}
              onClick={() => navigate('/form-o-4')}
              >
              <img
                  src={getImageByStatus(
                  getPreferredStatus(
                      statusData?.o4_status,
                      statusData?.o4_host_status,
                  )
                  )}
                  alt="物品販売ステータス"
                  style={{ width: '60px' }}
              />
              <Typography>床面工事施工申込</Typography>
              </Box>

              <Box
              sx={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '24%',
                  borderRight: '1px solid #ccc',
                  padding: '0 10px',
                  boxSizing: 'border-box',
                  gap: 1,
                  cursor: 'pointer',
                  '&:last-child': { borderRight: 'none' },
              }}
              onClick={() => navigate('/form-elec')}
              >
              <img
                  src={getImageByStatus(
                  getPreferredStatusForElec(
                    statusData?.o5_status,
                    statusData?.o6_status,
                    statusData?.o5_host_status,
                    statusData?.o6_host_status
                  )
                  )}
                  alt="食品販売ステータス"
                  style={{ width: '60px' }}
              />
              <Typography>電気使用・電気備品レンタル申込</Typography>
              </Box>

              <Box
              sx={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '24%',
                  borderRight: '1px solid #ccc',
                  padding: '0 10px',
                  boxSizing: 'border-box',
                  gap: 1,
                  cursor: 'pointer',
                  '&:last-child': { borderRight: 'none' },
              }}
              onClick={() => navigate('/form-o-7')}
              >
              <img
                  src={getImageByStatus(
                  getPreferredStatus(
                      statusData?.o7_status,
                      statusData?.o7_host_status,
                  )
                  )}
                  alt="食品取扱関係調査ステータス"
                  style={{ width: '60px' }}
              />
              <Typography>給排水・エア・ガス工事申込</Typography>
              </Box>
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'space-around' , borderBottom: '1px solid #ccc' , pb: 1 }}>
              {/* 5〜8個目 */}
              <Box
              sx={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '24%',
                  borderRight: '1px solid #ccc',
                  padding: '0 10px',
                  boxSizing: 'border-box',
                  gap: 1,
                  cursor: 'pointer',
                  '&:last-child': { borderRight: 'none' },
              }}
              onClick={() => navigate('/form-o-8')}
              >
              <img
                  src={getImageByStatus(
                  getPreferredStatus(
                      statusData?.o8_status,
                      statusData?.o8_host_status,
                  )
                  )}
                  alt="リース備品申請書ステータス"
                  style={{ width: '60px' }}
              />
              <Typography>パッケージ装飾・出展者専用倉庫・名刺交換用iPhone・パッケージプラン申込</Typography>
              </Box>

              <Box
              sx={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '24%',
                  borderRight: '1px solid #ccc',
                  padding: '0 10px',
                  boxSizing: 'border-box',
                  gap: 1,
                  cursor: 'pointer',
                  '&:last-child': { borderRight: 'none' },
              }}
              onClick={() => navigate('/form-o-9')}
              >
              <img
                  src={getImageByStatus(
                  getPreferredStatus(
                      statusData?.o9_status,
                      statusData?.o9_host_status,
                  )
                  )}
                  alt="インターネット回線申請書ステータス"
                  style={{ width: '60px' }}
              />
              <Typography>装飾備品レンタル申込</Typography>
              </Box>

              <Box
              sx={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '24%',
                  borderRight: '1px solid #ccc',
                  padding: '0 10px',
                  boxSizing: 'border-box',
                  gap: 1,
                  cursor: 'pointer',
                  '&:last-child': { borderRight: 'none' },
              }}
              onClick={() => navigate('/form-o-10')}
              >
              <img
                  src={getImageByStatus(
                  getPreferredStatus(
                      statusData?.o10_status,
                      statusData?.o10_host_status,
                  )
                  )}
                  alt="PCレンタル申請書ステータス"
                  style={{ width: '60px' }}
              />
              <Typography>インターネット接続、PC・ソフトレンタル申込</Typography>
              </Box>

              <Box
              sx={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '24%',
                  borderRight: '1px solid #ccc',
                  padding: '0 10px',
                  boxSizing: 'border-box',
                  gap: 1,
                  cursor: 'pointer',
                  '&:last-child': { borderRight: 'none' },
              }}
              onClick={() => navigate('/form-o-11')}
              >
              <img
                  src={getImageByStatus(
                  getPreferredStatus(
                      statusData?.o11_status,
                      statusData?.o11_host_status,
                  )
                  )}
                  alt="電気使用申請書ステータス"
                  style={{ width: '60px' }}
              />
              <Typography>防炎対象物品申請・危険物品の許可申請</Typography>
              </Box>
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'flex-start', pb: 2 }}>
              {/* 9〜11個目 */}
              <Box
              sx={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '24.5%',
                  borderRight: '1px solid #ccc',
                  padding: '0 10px',
                  boxSizing: 'border-box',
                  gap: 1,
                  cursor: 'pointer',
                  '&:last-child': { borderRight: 'none' },
              }}
              onClick={() => navigate('/form-o-12')}
              >
              <img
                  src={getImageByStatus(
                  getPreferredStatus(
                      statusData?.o12_status,
                      statusData?.o12_host_status,
                  )
                  )}
                  alt="ガス使用申請書ステータス"
                  style={{ width: '60px' }}
              />
              <Typography>ゴミ・廃材・廃油処理と小間内清掃申込</Typography>
              </Box>

              <Box
              sx={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '24%',
                  borderRight: '1px solid #ccc',
                  padding: '0 10px',
                  boxSizing: 'border-box',
                  gap: 1,
                  cursor: 'pointer',
                  '&:last-child': { borderRight: 'none' },
              }}
              onClick={() => navigate('/form-o-13')}
              >
              <img
                  src={getImageByStatus(
                  getPreferredStatus(
                      statusData?.o13_status,
                      statusData?.o13_host_status,
                  )
                  )}
                  alt="水道使用申請書ステータス"
                  style={{ width: '60px' }}
              />
              <Typography>ブース平面図</Typography>
              </Box>
          </Box>
          </Container>
      </Box>
      </>
    );
  }
  if (parentExhibit === false) {
  return (
    <Box sx={{ margin: 'auto', mt: 4 }}>
      <Typography variant="h6" gutterBottom>
        自社出展【しない】と登録されています。
      </Typography>
      <Box sx={{ margin: 'auto', mt: 4 }}>
        <Typography variant="h6" gutterBottom>
          自社出展の設定を変更する場合はこちらから変更してください。
        </Typography>
        <RadioGroup
          value={ownExhibit}
          onChange={(e) => setOwnExhibit(e.target.value)}
          row
          aria-label="own-exhibit"
          name="own-exhibit-group"
        >
          <FormControlLabel value="yes" control={<Radio />} label="自社出展する" />
          <FormControlLabel value="no" control={<Radio />} label="自社出展しない" />
        </RadioGroup>
        <Button
          variant="contained"
          sx={{ mt: 2 }}
          onClick={handleSave}
          disabled={saving || ownExhibit === ""}
        >
          保存する
        </Button>
        <Box>
          <Typography color='error' variant='h6'>必須書類をご提出ください。また、必要に応じてブース内の子出展者配置図をアップロードください。</Typography>
          <Box sx={{display: 'flex', justifyContent: 'center', gap: 4}}>
            <Box>
              <Typography>必須書類</Typography>
              <img
                  src={getImageByStatus(
                  getPreferredStatus(
                      statusData?.r1_status,
                      statusData?.r1_host_status,
                  )
                  )}
                  alt="水道使用申請書ステータス"
                  style={{ width: '60px' }}
                  onClick={() => navigate('/form-require')}
              />
            </Box>
            <Box>
              <Typography>ブース平面図</Typography>
              <img
                  src={getImageByStatus(
                  getPreferredStatus(
                      statusData?.o13_status,
                      statusData?.o13_host_status,
                  )
                  )}
                  alt="水道使用申請書ステータス"
                  style={{ width: '60px' }}
                  onClick={() => navigate('/form-o-13')}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
  };
}

useConfirmBackLogout(navigate);

if (loading) return <div>読み込み中...</div>;

  return (
    <div>
      <Header
        title="SDGs 子ども・ユースフェア2026 共同出展親出展者マイページ"
        companyName={mypageData?.company_name}
      />
       <Container sx={{ display: 'flex' }}>
        <Container sx={{ width: '22%', mt: 4 }}>
          <Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box
                className={`menu-item`}
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`${user?.mypage_url}`);
                }}
              >
                TOP
              </Box>
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`/mypage-info/${user?.exhibitor_id}`);
                }}
              >
                出展者情報編集
              </Box>
              <Box 
                className="menu-item"
                onClick={() => {
                  if (canDownload) {
                    handlePdfDownload(mypageData.exhibitor_id, mypageData.company_name);
                  }
                }}
                style={{
                  cursor: canDownload ? "pointer" : "not-allowed",
                  opacity: canDownload ? 1 : 0.5,
                }}
              >
                見積書発行
              </Box>
              <Box 
                className="menu-item"
                onClick={() => {
                  navigate('/mail-form/');
                }}
              >
                お問い合わせ
              </Box>
              {renderMenuItems()}
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user') || '{}');
                  const mypage = user?.mypage_url;

                  handleScrollTo('news', mypage);
                }}
              >
                お知らせ
              </Box>
              <Box
                className="menu-item"
                onClick={() => window.open('https://sdgs-aichi.com/privacy/index.html', '_blank', 'noopener,noreferrer')}
              >
                個人情報保護方針
              </Box>
            </Box>
          </Box>
        </Container>
        <Container sx={{ width: '80%'}}>
          <p className="remind">
            締切日: {deadline.toLocaleDateString()}(火)<br />
            {remainingDays > 0
              ? `締め切りまであと${remainingDays}日`
              : "締め切りました"}
          </p>
          {/* <FormRequire /> */}
          <Box sx={{ margin: 'auto', mt: 4 }} className="form-status-box">
            <Typography variant="h6" className='form-status-title' gutterBottom>　共同出展者全体申請書提出状況</Typography>
            <Container sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
              {/* 必須書類のまま */}
              <Box sx={{ textAlign: 'center', borderBottom: '1px solid #0071BC', pb: 2 }}>
                  <Typography>全出展者提出書類<br />出展責任者登録、搬入・搬出計画登録</Typography>
                  <img
                  src={getImageByStatusCo(
                      coStatusData?.r1_co
                  )}
                  alt="必須書類ステータス"
                  style={{ width: '60px' }}
                  />
              </Box>

              <Typography sx={{textAlign: 'center'}}>希望者・対象者提出書類</Typography>

              {/* 任意書類 横4つずつ */}
              <Box sx={{ display: 'flex', justifyContent: 'space-around', borderBottom: '1px solid #ccc', pb: 1 }}>
                  {/* 1〜4個目 */}
                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  >
                  <img
                      src={getImageByStatusCo(
                        coStatusData?.o3_co
                    )}
                      alt="パッケージプランステータス"
                      style={{ width: '60px' }}
                  />
                  <Typography>運送・会場内荷役作業申込</Typography>
                  </Box>

                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  >
                  <img
                      src={getImageByStatusCo(
                        coStatusData?.o4_co
                    )}
                      alt="物品販売ステータス"
                      style={{ width: '60px' }}
                  />
                  <Typography>床面工事施工申込</Typography>
                  </Box>

                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  >
                  <img
                      src={getImageByStatusCo(
                        coStatusData?.o5_co
                    )}
                      alt="食品販売ステータス"
                      style={{ width: '60px' }}
                  />
                  <Typography>電気使用・電気備品レンタル申込</Typography>
                  </Box>

                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  >
                  <img
                      src={getImageByStatusCo(
                        coStatusData?.o7_co
                      )}
                      alt="食品取扱関係調査ステータス"
                      style={{ width: '60px' }}
                  />
                  <Typography>給排水・エア・ガス工事申込</Typography>
                  </Box>
              </Box>

              <Box sx={{ display: 'flex', justifyContent: 'space-around' , borderBottom: '1px solid #ccc' , pb: 1 }}>
                  {/* 5〜8個目 */}
                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  >
                  <img
                      src={getImageByStatusCo(
                          coStatusData?.o8_co
                      )}
                      alt="リース備品申請書ステータス"
                      style={{ width: '60px' }}
                  />
                  <Typography>パッケージ装飾・出展者専用倉庫・名刺交換用iPhoneパッケージプラン申込</Typography>
                  </Box>

                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  >
                  <img
                      src={getImageByStatusCo(
                          coStatusData?.o9_co
                      )}
                      alt="インターネット回線申請書ステータス"
                      style={{ width: '60px' }}
                  />
                  <Typography>装飾備品レンタル申込</Typography>
                  </Box>

                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  >
                  <img
                      src={getImageByStatusCo(
                          coStatusData?.o10_co
                      )}
                      alt="PCレンタル申請書ステータス"
                      style={{ width: '60px' }}
                  />
                  <Typography>インターネット接続、PC・ソフトレンタル申込</Typography>
                  </Box>

                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  >
                  <img
                      src={getImageByStatusCo(
                          coStatusData?.o11_co
                      )}
                      alt="電気使用申請書ステータス"
                      style={{ width: '60px' }}
                  />
                  <Typography>防炎対象物品申請・危険物品の許可申請</Typography>
                  </Box>
              </Box>

              <Box sx={{ display: 'flex', justifyContent: 'flex-start', pb: 2 }}>
                  {/* 9〜11個目 */}
                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24.5%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  >
                  <img
                      src={getImageByStatusCo(
                          coStatusData?.o12_co
                      )}
                      alt="ガス使用申請書ステータス"
                      style={{ width: '60px' }}
                  />
                  <Typography>ゴミ・廃材・廃油処理と小間内清掃申込</Typography>
                  </Box>

                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  >
                  <img
                      src={getImageByStatusCo(
                          coStatusData?.o13_co
                      )}
                      alt="水道使用申請書ステータス"
                      style={{ width: '60px' }}
                  />
                  <Typography>ブース平面図</Typography>
                  </Box>
              </Box>
              </Container>
          </Box>
          <Box>
            {renderMainContent()}
          </Box>

          <Box className="notice-box" sx={{ px:2, py:3,  }}>
            <Box>
              <Typography variant='h5' className='title' sx={{ mb: 3, px: 4 }}>申請書一覧</Typography>
              <Typography color='error'>※親企業も含め全てのステータスが「確認中」「申請しない」となった場合に以下の「提出」がクリック可能となります。親企業が「提出」ボタンを押した後、事務局へ届出が提出されます。</Typography>
            </Box>
            <Box sx={{ overflowX: 'auto' }}>
              {/* 見出しラベル */}
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 0, backgroundColor: '#0071BC', color: '#FFF', textAlign: 'center' , minWidth: '1490px', overflowX: 'hidden' }}>
                <Typography sx={{ padding: '10px 0' ,width: 120, fontWeight: 'bold', borderRight: '1px solid #fff' }}>会社名</Typography>
                {getVisibleFields().map((field) => (
                  <React.Fragment key={field.key}>
                    <Typography sx={{ padding: '10px 0', width: 110, fontWeight: 'bold', borderRight: '1px solid #fff' }}>
                      {field.label}
                    </Typography>
                  </React.Fragment>
                ))}
              </Box>
              <Box>
                <>
                  {paginatedExhibitors.map((exhibitor, index) => {
                    const isEven = index % 2 === 0;

                    return (
                      <Box
                        key={exhibitor.exhibitor_id}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          mb: 0,
                          textAlign: 'center',
                          backgroundColor: isEven ? '#f5f5f5' : '#ffffff',
                          border: '1px solid #ccc',
                          minWidth: '1490px',
                          overflowX: 'hidden'
                        }}
                      >
                        {/* 出展者の情報 */}
                        <Typography
                          sx={{
                            width: 120,
                            borderRight: '1px solid #ccc',
                            py: 1 
                          }}
                          onClick={() => {
                            setMypageExhibitorId(exhibitor.exhibitor_id);
                            setMypageModalOpen(true);
                          }}
                        >
                          {exhibitor.company_name}
                        </Typography>

                        {/* 出展者書類のステータス画像 */}
                        {getVisibleFields().map((field) => {
                          const { key, label } = field;
                          const exhibitorKey = `${key}_exhibitor_status`;
                          const hostKey = `${key}_host_status`;
                          const corporateKey = `${key}_corporate_status`;

                          // === o5/o6特例: exhibitor_status 判定 ===
                          let exhibitorStatus = exhibitor[exhibitorKey] ?? '未提出';

                          if (key === 'o5') {
                            const o5 = exhibitor.o5_exhibitor_status;
                            const o6 = exhibitor.o6_exhibitor_status;

                            if (o5 === '申請しない' && (o6 === '未提出' || o6 === '提出済み')) {
                              exhibitorStatus = o6;
                            } else if (o5 === '申請しない' && o6 === '申請しない') {
                              exhibitorStatus = '申請しない';
                            } else {
                              exhibitorStatus = o5 ?? '未提出';
                            }
                          }

                          // === o5/o6特例: host_status 判定 ===
                          let hostStatus = exhibitor[hostKey];

                          if (key === 'o5') {
                            const o5 = exhibitor.o5_host_status;
                            const o6 = exhibitor.o6_host_status;

                            if (o5 === '申請しない' && (o6 === '未確認' || o6 === '確認済')) {
                              hostStatus = o6;
                            } else if (o5 === '申請しない' && o6 === '申請しない') {
                              hostStatus = '申請しない';
                            } else {
                              hostStatus = o5;
                            }
                          }

                          // === 全候補から最強を決める ===
                          const candidates = [exhibitorStatus, hostStatus, exhibitor[corporateKey]].filter(Boolean);

                          const STATUS_PRIORITY = [
                            '再提出',
                            '確認済',
                            '申請しない',
                            '提出済み',
                            '確認中',
                            '未確認',
                            '1のみ確認済',
                            '2のみ確認済',
                            '未提出'
                          ];

                          let currentStatus = '未提出';
                          for (const status of STATUS_PRIORITY) {
                            if (candidates.includes(status)) {
                              currentStatus = status;
                              break;
                            }
                          }

                          const imgSrc = getStatusImage(currentStatus);
                          console.log(
                            `[${label}]`,
                            {
                              exhibitorStatus,
                              hostStatus,
                              corporateStatus: exhibitor[corporateKey],
                              candidates,
                              currentStatus,
                              imgSrc
                            }
                          );

                          return (
                            <Box
                              key={key}
                              sx={{
                                width: 110,
                                borderRight: '1px solid #ccc',
                                py: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: 2,
                              }}
                            >
                              <img
                                src={imgSrc}
                                alt={`${label} ステータス`}
                                className="max-61"
                                onClick={
                                  !field.contractor
                                    ? () => handleStatusClick(key, exhibitor.exhibitor_id, currentStatus)
                                    : field.contractor
                                    ? () => {
                                        setSelectedExhibitorId(exhibitor.exhibitor_id);
                                        setSelectedFormKey(key);
                                        setFormModalOpen(true);
                                      }
                                    : undefined
                                }
                                style={{
                                  cursor: !field.contractor ? 'pointer' : 'default',
                                  opacity: 1,
                                }}
                              />
                            </Box>
                          );
                        })}

                        {/* モーダル */}
                      <Modal open={formModalOpen} onClose={() => setFormModalOpen(false)}>
                        <Box
                          sx={{
                            p: 4,
                            backgroundColor: 'white',
                            width: '95%',
                            margin: 'auto',
                            mt: 10,
                            maxHeight: '90vh',
                            overflowY: 'auto',
                            position: 'relative', // ←これ追加
                          }}
                        >
                          {/* ×ボタン */}
                          <IconButton
                            onClick={() => setFormModalOpen(false)}
                            sx={{
                              position: 'absolute',
                              top: 8,
                              right: 8,
                            }}
                          >
                            <CloseIcon />
                          </IconButton>

                          <div>{renderForm(selectedFormKey, selectedExhibitorId)}</div>
                        </Box>
                      </Modal>

                      <Modal open={mypageModalOpen} onClose={() => setMypageModalOpen(false)}>
                        <Box
                          sx={{
                            p: 4,
                            backgroundColor: 'white',
                            width: '60%',
                            margin: 'auto',
                            mt: 10,
                            maxHeight: '80vh',
                            overflowY: 'auto',
                            borderRadius: 2,
                            position: 'relative'
                          }}
                        >
                          <IconButton
                            onClick={() => setMypageModalOpen(false)}
                            sx={{
                              position: 'absolute',
                              top: 8,
                              right: 8,
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                          {coMypageData ? (
                            <Box>
                              <Typography variant="h6" sx={{ mb: 2 }}>マイページ情報</Typography>
                              <Typography>小間番号: {coMypageData.booth_number}</Typography>
                              <Typography>会社名: {coMypageData.company_name}</Typography>
                              <Typography>部署: {coMypageData.department}</Typography>
                              <Typography>担当者名: {coMypageData.user_name}</Typography>
                              <Typography>郵便番号: {coMypageData.zip_code}</Typography>
                              <Typography>住所: {coMypageData.address}</Typography>
                              <Typography>電話番号: {coMypageData.phone_number}</Typography>
                              <Typography>メールアドレス: {coMypageData.email}</Typography>
                            </Box>
                          ) : (
                            <Typography>読み込み中...</Typography>
                          )}
                        </Box>
                      </Modal>
                      </Box>
                    );
                  })}
                </>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: 0,
                  textAlign: 'center',
                  backgroundColor: '#d9eaff',
                  border: '1px solid #ccc',
                  minWidth: '1490px',
                  overflowX: 'hidden'
                }}
              >
                {/* 会社名の列は空白か「提出」とか表示 */}
                <Typography sx={{ width: 120, borderRight: '1px solid #ccc', py: 1, fontWeight: 'bold' }}>
                  提出
                </Typography>

                {/* 11種類分の提出ボタン */}
                {getVisibleFields().map((field) => {
                    // categoryごとの振り分け処理（ステータス取得用）
                    let targetKeys = field.key;
                    if ([1, 2].includes(field.category)) {
                      targetKeys = 'r1';
                    } else if ([5, 6].includes(field.category)) {
                      targetKeys = 'o5';
                    }

                    let targetCategory = field.category;
                    if ([1, 2].includes(field.category)) {
                      targetCategory = 1;
                    } else if ([5, 6].includes(field.category)) {
                      targetCategory = 5;
                    }

                    const statusCo = `submission_${targetCategory}_status`

                    // ステータスカラム名
                    const statusColumn = `${targetKeys}_exhibitor_status`;

                    // exhibitorsの中で全員が「提出済み」か「申請しない」かを判定
                    const allSubmittedOrNoApply = exhibitors.every((exhibitor) => {
                      const status = exhibitor[statusColumn];
                      return status === "提出済み" || status === "申請しない";
                    });

                    return (
                      <Box key={field.key} sx={{ width: 110, borderRight: '1px solid #ccc', py: 1 }}>
                        <button
                          disabled={!allSubmittedOrNoApply}
                          style={{
                            padding: '6px 12px',
                            borderRadius: 4,
                            border: 'none',
                            backgroundColor: allSubmittedOrNoApply ? '#0071BC' : '#999999',
                            color: 'white',
                            cursor: allSubmittedOrNoApply ? 'pointer' : 'not-allowed',
                            width: '100%',
                          }}
                          onClick={async () => {
                            if (!allSubmittedOrNoApply) return; // 念のためクリック無効化

                            try {
                              await api.post(`/api/exhibitors/update-status`, {
                                exhibitor_id: user?.exhibitor_id,
                                status_column: statusCo,
                                status_value: "提出済み",
                              });
                              alert(`${field.label} のステータスを更新しました`);
                            } catch (error) {
                              console.error(error);
                              alert("ステータス更新に失敗しました");
                            }
                          }}
                        >
                          提出
                        </button>
                      </Box>
                    );
                  })}
              </Box>
            </Box>
          </Box>
          <Box sx={{ mt: 6 }} className="notice-box" id="news">
            <Typography variant="h6" className='notice-title' gutterBottom>
              SDGs 子ども・ユースフェア事務局からのお知らせ
            </Typography>

            {notices
              .filter((notice) => notice.visibility_setting !== '協力会社')
              .filter((notice) => {
                const noticeDate = new Date(notice.date); // notice.date を Date オブジェクトに変換
                return noticeDate <= now; // 現在時刻以前のお知らせのみ
              })
              .map((notice, index) => (
                <Box key={index} sx={{ mb: 2, p: 2 , display: 'flex', alignItems: 'center' }}>
                  <Box
                    sx={{
                      display: 'inline-block',
                      px: 2,
                      py: 0.5,
                      mb: 0,
                      mx: 0.5,
                      borderRadius: '4px',
                      backgroundColor:
                        notice.category === '緊急' ? '#c1272d' :
                        notice.category === '重要' ? '#f7931e' :
                        '#0071bc',
                      color: 'white',
                      fontWeight: 'bold',
                      fontSize: '20px'
                    }}
                  >
                    {notice.category}
                  </Box>
                  <Typography variant="h6" color="text.secondary" sx={{ mr: 2 }}>
                    {notice.date}
                  </Typography>
                  <Typography variant="h6">{notice.title}</Typography>
                  <Link to={`/news/${notice.notice_id}`} component={RouterLink} sx={{ mt: 1, display: 'block' }}>
                    　詳細を見る
                  </Link>
                </Box>
              ))
            }

            {/* ページネーション */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
              {Array.from({ length: Math.ceil(total / noticesPerPage) }).map((_, idx) => (
                <Button
                  key={idx}
                  onClick={() => handlePageChange(idx + 1)}
                  variant={page === idx + 1 ? 'contained' : 'outlined'}
                  sx={{ mx: 0.5 }}
                >
                  {idx + 1}
                </Button>
              ))}
            </Box>
          </Box>
        </Container>
       </Container>
       <footer>
        <Typography>
          © 2026 THE MID-JAPAN ECONOMIST.
        </Typography>
       </footer>
    </div>
  );
};

export default CoExhibitMypage;